import type { RefinedFetchError } from '../common/types';

/**
 *
 * @param obj
 * @returns undefined and doesn't throw in case error is of another type which we still want to log
 */
export const refineFetchError = (obj: unknown): RefinedFetchError | undefined => {
	if (
		!obj ||
		typeof obj !== 'object' ||
		!('statusCode' in obj) ||
		typeof obj.statusCode !== 'number' ||
		('traceId' in obj && typeof obj.traceId !== 'string') ||
		('message' in obj && typeof obj.message !== 'string')
	) {
		return undefined;
	}
	let traceId: string | undefined;
	let message: string | undefined;

	if ('traceId' in obj && typeof obj.traceId === 'string') {
		traceId = obj.traceId;
	}
	if ('message' in obj && typeof obj.message === 'string') {
		message = obj.message;
	}

	return {
		statusCode: obj.statusCode,
		message,
		traceId,
	};
};
